import Model, { attr, belongsTo } from "@ember-data/model";
import { tKey } from "ember-intl";

const STATUS = {
  UP: { state: "online", labelKey: tKey("component.load-balancer-target.status.up") },
  DOWN: { state: "error", labelKey: tKey("component.load-balancer-target.status.down") },
};

export default class LoadBalancerTargetModel extends Model {
  @attr("yesno") active;
  @attr ipaddress;
  @attr name;
  @attr port;
  @attr status;
  @attr weight;

  @belongsTo("load-balancer-listener", { async: false, inverse: "targets" }) listener;

  get isDirty() {
    return this.hasDirtyAttributes || this.isDeleted;
  }

  get statusIndicator() {
    return STATUS[this.status] ?? { state: "offline", labelKey: tKey("component.load-balancer-target.status.unknown") };
  }
}
